import React from 'react'

function About() {
    return (
        <>
        <div className="my-2">
            <h1 className="text-center" > About Us</h1>
        </div>
        <div className="container-fluid mb-5">
            <div className="row">
                <div className="col-10 mx-auto">
                    <div className='row gy-4'></div>
                </div>
            </div>
        </div>
        </>
    )
}

export default About
